import React from "react";
import { Grid, Box, Typography, TextField } from "@mui/material";
import { Image } from "semantic-ui-react";
import { SubtitleInline } from "components/shared/Typography";
import { displayCoveragesProperties, formatContent, displayCoverageLimits, getCoverageFullName } from "utils/projectCoverageRequirementsUtils";

export default function DisplayProjectDescriptionOfOperation ({ descriptionOfOperation }) {
  if (!descriptionOfOperation) {
    return null;
  }

  return (
    <Box component="div" width="100%" my={2}>
      <SubtitleInline >DESCRIPTION OF OPERATION</SubtitleInline>
      <TextField
        sx={{ 
          mt: 1,
          '& .MuiInputBase-input.Mui-disabled': {
            color: 'rgba(0,0,0,0.6)',
            WebkitTextFillColor: 'rgba(0,0,0,0.6)'
          }
        }}
        fullWidth
        multiline
        placeholder={"Add description of operation ..."}
        name="descriptionOfOperation"
        value={descriptionOfOperation}
        disabled={true}
      />
    </Box>
  );
}
